import { render, staticRenderFns } from "./FlatRent.vue?vue&type=template&id=560941bc"
import script from "./FlatRent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatRent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports